@if (infoText) {
  <div class="udex-grid udex-mx-auto mb-4">
    <div class="row">
      @if (!g2Product.review_count) {
        <div class="col-12 mb-5 body--s--l text-center mx-auto">
          {{ 'productReview.beTheFirstToReview' | cxTranslate }}
        </div>
      }
      @if (g2Product.review_count) {
        <div [class.body--s--l]="pageCount === 0" [class.mt-6]="pageCount !== 0" class="col-12 mb-5 text-center">
          {{ infoText }}
        </div>
      }
      <div class="col-12 text-center">
        <dcp-write-review [btnLabel]="btnText" [g2Product]="g2Product"></dcp-write-review>
      </div>
    </div>
  </div>
}
